/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Create_Team_PromptInputs */



/**
* | output |
* | --- |
* | "Please create a new team to begin." |
*
* @param {Team_Share_Create_Team_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_create_team_prompt = /** @type {((inputs?: Team_Share_Create_Team_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Create_Team_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez créer une nouvelle équipe pour commencer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte erstellen Sie zunächst ein neues Team.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per iniziare, crea un nuovo team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, создайте новую команду, чтобы начать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor crea un nuevo equipo para comenzar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请创建一个新团队开始。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには新しいチームを作成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया शुरुआत करने के लिए एक नई टीम बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, crie uma nova equipe para começar.")
	return /** @type {LocalizedString} */ ("Please create a new team to begin.")
});